import React, { useState } from "react";
import { Link } from "react-router-dom";
import { PropagateLoader } from "react-spinners";
import ModalConfirm from "../ModalConfirm";

const AccesoDF = ({
  href,
  label,
  label2,
  icon,
  disabled,
  onCreate,
  loading = false,
  confirmOnCreate = false,
}) => {
  const [showConfirm, setShowConfirm] = useState(false);

  const baseClass =`relative w-full h-44 flex flex-col items-center justify-center p-4 text-center rounded-lg
    ${label2 === "Iniciado" ? "bg-green-600" : (label2 === "Revisión" ? "bg-yellow-500" : ( label2 === "Concluido" ? "bg-orange-700" : (label2 ? "bg-rs-azul" : "bg-gray-700"))) }
    hover:bg-orange-500 shadow-md shadow-gray-500 transition transform hover:scale-105 shadow-black hover:shadow-xl hover:shadow-orange-600
  `;

  if (!disabled && href) {
    return (
      <Link to={href} className={baseClass}>
        {React.createElement(icon, { size: 40, color: "white" })}
        <h2 className="text-white text-lg font-bold">{label}</h2>
        <p className="text-white">{label2}</p>
      </Link>
    );
  }

  const handleClick = async () => {
    if (!onCreate || loading) return;
    if (confirmOnCreate) {
      setShowConfirm(true);
    } else {
      await onCreate();
    }
  };

  return (
    <>
      <button
        type="button"
        onClick={handleClick}
        className={`${baseClass} bg-gray-600 ${loading ? "opacity-70 cursor-not-allowed" : ""}`}
        disabled={loading}
      >
        {React.createElement(icon, { size: 40, color: "white" })}
        <h2 className="text-white text-lg font-bold">{label}</h2>

        {loading && (
          <div className="absolute inset-0 flex items-center justify-center bg-black/20 rounded-lg">
            <PropagateLoader color="red" />
          </div>
        )}
      </button>

      {showConfirm && (
        <ModalConfirm
          onClose={() => setShowConfirm(false)}
          onConfirm={async () => {
            setShowConfirm(false);
            if (onCreate) await onCreate();
          }}
          eliminacion={false}
        />
      )}
    </>
  );
};

export default AccesoDF;
